<kendo-dialog-titlebar kendo-dialog-title>
  <div translate>App.Update</div>
</kendo-dialog-titlebar>

<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
<form
  kendoForm
  [formGroup]="updateEntityForm"
  [cols]="1"
>
  @if (updateEntityForm.touched && updateEntityForm.errors?.['required']) {
  <div class="k-messagebox k-messagebox-error">
    <span translate>App.AtLeastOneChangeMustBeSelected</span>
  </div>
  }
  <fieldset
    kendoFormFieldSet
    legend="{{ 'App.State' | translate }}"
    formGroupName="state"
    [cols]="3"
  >
    <kendo-formfield [colSpan]="2">
      <kendo-label translate>App.Change</kendo-label>
      <kendo-switch
        formControlName="change"
        color="primary"
      ></kendo-switch>
    </kendo-formfield>
    <kendo-formfield>
      <kendo-label translate>App.Status</kendo-label>
      <app-select-entity-status formControlName="status"></app-select-entity-status>
    </kendo-formfield>
  </fieldset>
  <fieldset
    kendoFormFieldSet
    legend="{{ 'App.Property' | translate }}"
    formGroupName="property"
    [cols]="3"
  >
    <kendo-formfield>
      <kendo-label translate>App.Change</kendo-label>
      <kendo-switch
        formControlName="change"
        color="primary"
      ></kendo-switch>
    </kendo-formfield>
    <kendo-formfield>
      <kendo-label translate>App.Code</kendo-label>
      <app-select-property-code
        [properties]="props"
        formControlName="code"
      ></app-select-property-code>
    </kendo-formfield>
    <kendo-formfield>
      <kendo-label translate>App.Value</kendo-label>
      <app-select-valid-value
        formControlName="value"
        [property]="getPropertyByCode(updateEntityForm.get('property.code')?.value)"
        [entityGroupIndex]="1"
      ></app-select-valid-value>
    </kendo-formfield>
  </fieldset>
  <fieldset
    kendoFormFieldSet
    legend="{{ 'App.UnitConversion' | translate }}"
    formGroupName="unitConversion"
    [cols]="3"
  >
    <kendo-formfield>
      <kendo-label translate>App.Change</kendo-label>
      <kendo-switch
        formControlName="change"
        color="primary"
      ></kendo-switch>
    </kendo-formfield>
    <kendo-formfield>
      <kendo-label translate>App.UnitCode</kendo-label>
      <app-select-unit formControlName="unitCode"></app-select-unit>
    </kendo-formfield>
    <kendo-formfield>
      <kendo-label translate>App.ConvFactor</kendo-label>
      <kendo-numerictextbox
        formControlName="convFactor"
        [decimals]="5"
        [format]="'n5'"
      ></kendo-numerictextbox>
    </kendo-formfield>
  </fieldset>
</form>
<kendo-dialog-actions layout="end">
  <div class="btn-holder">
    <button
      kendoButton
      themeColor="error"
      type="button"
      class="closebtn"
      (click)="close(false)"
      title="{{ 'App.Close' | translate }}"
      [svgIcon]="cancelIcon"
    ></button>
    <button
      kendoButton
      themeColor="primary"
      type="submit"
      (click)="save()"
      [disabled]="updateEntityForm.invalid"
      title="{{ 'App.Submit' | translate }}"
      [svgIcon]="saveIcon"
    ></button>
  </div>
</kendo-dialog-actions>
